<script lang="ts" setup>
import PalkLogoColor from "@/components/PalkLogoColor.vue";
import {watch} from "vue";
import type {LoginBanner} from "@/features/login-banner/LoginBanner.ts";
import {useFetch} from "@/api/composables/useFetch.ts";

import {LoginBannerEndpoints} from "@/features/login-banner/LoginBannerEndpoints.ts";

defineOptions({
  name: 'LoginBanner',
})

const {
  data: model,
  isLoading,
  error,
} = useFetch<LoginBanner>(LoginBannerEndpoints.GET);

const redirect = () => {
  if (model.value != null && model.value.url) {
    window.open(model.value.url, '_blank');
  }
}

watch(model, (value) => {
  if (typeof window.signalVueComponentReady === 'function') {
    window.signalVueComponentReady();
  }
});


</script>

<template>
  <div v-if="model"
       :style="model.image ? { backgroundImage: `url('data:${model.imageMimeType};base64,${model.image}')` } : {}"
       :class="['login-banner', { 'default-banner-image': !model.image }]"
       @click="redirect"
  >
    <div class="tagline-div" v-html="model.text"></div>
    <div v-if="!model.logoDisabled" class="logo-div">
      <palk-logo-color/>
    </div>
  </div>
</template>

<style scoped>
.login-banner {
  display: block;
  width: 600px;
  max-width: 600px;
  max-height: 590px;
  height: 590px;
  border-radius: 5px;
  position: relative;
  background-size: cover;
  background-size: calc(600px);
  cursor: pointer;
}

.default-banner-image {
  background: #222222 url('@/assets/login-banner-default.png') no-repeat center;
}

.tagline-div {
  padding: 50px;
  color: #fff;
  font-size: 36px;
  line-height: 46px;
  max-width: 550px;
}

.tagline-div ::v-deep(blockquote p),
.tagline-div ::v-deep(p) {
  margin-block-start: 10px;
  margin-block-end: 10px;
}

.logo-div {
  position: absolute;
  background-color: #fff;
  height: 51px;
  width: 176px;
  bottom: 39px;
  right: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
}

</style>